import React from 'react';
import { Bookmark } from 'lucide-react';
import { useEducationLibrary } from '../../utils/educationLibrary';

/**
 * Save / unsave an Education Center item on this device. Sits on top of a row or in the
 * viewer header; stops the tap from opening the row underneath.
 *   tone 'light'  for white cards (default)
 *   tone 'dark'   for the gradient featured cards
 */
const BookmarkButton = ({ item, className = '', size = 18, tone = 'light' }) => {
  const { isSaved, toggleSaved } = useEducationLibrary();
  const on = isSaved(item.id);
  const idle = tone === 'dark' ? 'text-emerald-200 hover:text-white' : 'text-gray-400 hover:text-gray-700 dark:hover:text-gray-200';
  const lit = tone === 'dark' ? 'text-amber-300' : 'text-emerald-600 dark:text-emerald-400';
  return (
    <button
      type="button"
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleSaved(item); }}
      aria-pressed={on}
      aria-label={on ? 'Remove bookmark' : 'Bookmark'}
      className={`p-2 rounded-full transition-colors active:scale-95 ${on ? `${lit} animate-pop` : idle} ${className}`}
    >
      <Bookmark size={size} className={on ? 'fill-current' : ''} />
    </button>
  );
};

export default BookmarkButton;
